import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LoadingProps {
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({ className }) => (
  <div
    className={twMerge(
      "relative bg-[#151515] md:rounded-2xl! overflow-hidden aspect-video text-white w-full h-full flex justify-center items-center text-[10px]",
      className
    )}
    role="status"
  >
    {/* Spinner inspired by Shaka Player's buffering indicator */}
    <div className=" flex justify-center items-center">
      <svg
        className="shaka-spinner-svg animate-spin h-12 w-12"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="shaka-spinner-path"
          cx="32"
          cy="32"
          r="28"
          strokeWidth="4"
          strokeLinecap="round"
          stroke="currentColor"
          fill="none"
          /* Create a gap so rotation is visible */
          strokeDasharray="176"
          strokeDashoffset="120"
        />
      </svg>
    </div>
    {/* <span className="sr-only">Loading...</span> */}
  </div>
); 